/** Clé partagée avec DriversApp pour rouvrir la fiche pilote. */
export const SELECTED_DRIVER_STORAGE_KEY = 'multirx-selected-driver-id';

/** Ouvre le garage pilotes sur la fiche demandée. */
export function openDriverDetail(driverId: number): void {
  sessionStorage.setItem(SELECTED_DRIVER_STORAGE_KEY, String(driverId));
  window.location.hash = `garage/pilotes/${driverId}`;
}
